import type { EmblaCarouselType } from 'embla-carousel'
import IntervalTimer from '../../utils/interval-timer'

interface AutoPlayType {
  play: () => void
  stop: () => void
  start?: () => void
  pause: () => void
}

export const oneAtTimeAutoPlay = (
  embla: EmblaCarouselType,
  interval: number,
): AutoPlayType => {
  const next = (): void => {
    const lastSlideIndex = embla.scrollSnapList().length - 1
    const isLastSlide = embla.selectedScrollSnap() === lastSlideIndex

    if (isLastSlide) {
      embla.scrollTo(0)
    } else {
      embla.scrollNext()
    }
  }

  const intervalTimer = new IntervalTimer(next, interval)

  const play = (): void => {
    intervalTimer.resume()
  }

  const stop = (): void => {
    intervalTimer.stop()
  }

  const pause = (): void => {
    intervalTimer.pause()
  }

  const start = (): void => {
    intervalTimer.start()
  }

  return { play, stop, start, pause }
}

export const seamlessAutoPlay = (
  embla: EmblaCarouselType,
  interval: number,
): AutoPlayType => {
  let tick = 0
  const engine = embla.internalEngine()
  const distance = interval / -5

  const animate = (): void => {
    engine.scrollTo.distance(distance)
    tick = requestAnimationFrame(animate)
  }

  const play = (): void => {
    tick = requestAnimationFrame(animate)
  }

  const pause = (): void => {
    tick = cancelAnimationFrame(tick) || 0
  }

  const stop = (): void => {
    cancelAnimationFrame(tick)
  }

  return { play, pause, stop }
}
